const PNCI_LOGO = `
<image preserveAspectRatio="none" id="logo_image" x="0" y="0" width= "94" height="30" 
xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQQAAABiCAYAAAC20q35AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8
YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAAHdElNRQfkBxQUFigeWPltAAAAB3RFWHRBdXRob3IAqa7M
SAAAAAx0RVh0RGVzY3JpcHRpb24AEwkhIwAAAAp0RVh0Q29weXJpZ2h0AKwPzDoAAAAOdEVYdENyZWF0
aW9uIHRpbWUANfcPCQAAAAl0RVh0U29mdHdhcmUAXXD/OgAAAAt0RVh0RGlzY2xhaW1lcgC3wLSPAAAA
CHRFWHRXYXJuaW5nAMAb5ocAAAAHdEVYdFNvdXJjZQD1/4PrAAAACHRFWHRDb21tZW50APbMlr8AAAAG
dEVYdFRpdGxlAKju0icAAAAhdEVYdENyZWF0aW9uIFRpbWUAMjAyMDowNzoyNyAyMDo0Mzo1NQrRgPwA
AD7RSURBVHhe7Z0HYFRV1sf/mUwqJCEJJfQqJfQW6R2kiQVcFRS7ItZdxM/K6qroWrF3RRAUQURUEKRJ
kd57Fwg1BBJIz0zynf99703eTGaSSdFd1vfTx+T1+24595xbzg3IF2BhYWEh2PRfCwsLC0sgWFhYFPDn
mAx8RZ5D3xFsdnlzgL5jYWHx30K5C4T8rAvIO7EDece3IO/sIeRfOA1kpgKOLOTLf/JKBNhDgfBKCIiM
g61yQ9hqtYWtejwCQipqD7GwsPiPUD4CITcTzv3L4NjxI5zHNiP//DE5liVPF4vEJpv8BsjmehFfme8U
rSFPfvMQEByOgOg6sNVpD3uLIQhs1BOwB+sXW1hY/FmUSSDkS83v2DAdjo3fIO/0Hq2QB4UBgcEiADST
QNMJ3DGOFQgIEQzOHOSLEAkQc8JWvTnsHW5EUPsbABEWFhYWfw6lFgi566cjd/m7yD+zVwmBgKBQKeDm
os893+0E5pe6XSXByReNA45sJRiCej0Ie5tr9ZMWFhZ/JCUWCGwXyPnxaTh3/yKCIETV6PlU+wOD5GkF
nRZsLyhKIBgY2oIZ41h+TrpoDg7YWw5F8JB/IaBSTXXewsLij6FEAsG5cx6yv38M+RdOISAsSgpsBgIi
qiIgJAL5546K5p8jKn5FrYCLkFAiwaM3oSgBQDz/Vu0NmSkIiKmLkGteQWDj3uqchYVF+eO3QMhd9RFy
5j0rd9jEPAhXvQn2tiMQPOAxJRzYmJi7+DU4Dv8GW2ikCIYKqo0hgIJBzImCQu5dczALAoOCYwEifNIA
WyBChr0Ie8dR6qjFpUFeXj6S0rKRdDEbyWk5yHA49TOSpFJhRIXYUSUyBFUqhiAyTDRNi/8YfgmE3KWT
kPPzRCCkgpgGwapw2mq2RtiYudqYAoPcLGR/9wgc676U860Q2HIYnNvmqAbHAAoJW5AU8jy5sEAkmF9e
WEyYEaHgzJJ3ZCPkyomwd7ldP15y1hxMxoQ52xAcbIfNRi1GP2HGkEbmX+IR8HzZ59eEBweiomTmyuHB
qFkpDHVjwtGgcgXUla2iZHhv5DjycPeXG3D6fCaC5H71aOP5npjC4ch2YFS3BhiZUEedKg+SpcDe99Um
pGc5VJw4cp14YmhzdG1UWb+iZBw4k4Yle05j6d4z2HHyAk6kZiE1MxfOHBEGbEQ2Yw9EaEggYiuEoL7E
W6cGsbiiWRy6N66CELs1du7PpFiBkLvqY+TMfQIIjVDtBYQ1f8jf3oa93d/UvhuS2Nlf34vctVMQ1OM+
BA98CrnL3oRj/TS5L0WeE6m6INWl6l8NPa+74Vk21HlnrgQqEyHD31A9EaVh3vaTGPL6UnmOZMwchzxY
nhwUqG2UDt4CY6Y4GcrTkpEDQ4NQS4RDQt1oXNm6Boa0rIGYCgXdqdkiEJr/awEOHjwr38WeFtkCJW5E
OKhfX6+RGjY8KgzrnxqA+OoiaMuBo+fSUfeJn4B0Mfv47qxcTPtH7xILnQU7T+G9pfvxiwiCzAsiwAkL
NZ9pxKtoDCoOGdcifNTGfSc3PR4kLZrVrIS7ezTEPT0bIoxpY/GHU6RAcOxagOxptyutAGw0JE4pQCIc
wu5foAYWeYONgVkfXQPn/l8ROuoT2BNuRt7JXaJpvAHHzvlyQZ7XQUjeAsI85I4ccWTLtfkIvXUaAht2
04/7T65kuNOSWY9LzbxLaq91v5/Dsn1J2HP0vGhBkvGYQQ0YKGNXCrCUYu08M7kSHrIZmZgZnfvMvDzP
fY61YK0ox2tWqYgxvRrh4X6NXVrDWamZT0rteTgpDZsTU7D68DlVq+ZIbarCYn6/+e+MHHRsUg2rxvdB
UDnUoonnMhD/3AJcNARCdi6+ua87rmtfW7+iaPaLRvDIzM2YuzFRi4tQ+T4+hxjxJvvhYhbEilAMljBn
iUBOlu/IuiiCg3FlvofZkvEmW6tGVfDh6A7oVD9WO2fxh+FTIOSd+x1ZHwxDfsZ51WZgFFd2Cdri4hF2
748FQsILHK2Y+f5gKTx2hN+/EAFVGqnjzr2LlQniPLxGnhsmhSdUHTfyuhEYI997Q3VvitkSEFVTmS2+
BFNJyBIV+Y1F+/DUd9uQx8FUzJdGoIhk6ipSK9/dvQHa1qqEahGhCAoSLUAKeo7U2KekUO89c1GEy3ms
PJCEs1JAEKZncOOj5B0QlbyVqOGT7+yknuONdSIUrvtwFY4mpyt12mdkiE0+7ppWePXaVvqB0pN4XgSC
aCulEQhzt57AHZPX4izDKyaTS6Dyu6XAR0WH49q2tTBMtKQ2tSshRq4JknfQZKJA2CyCePamRMzanKgJ
QsabEWdErgmXe2ZJeAY1L3taW/jGh0DIR9bkm+HYI1pAWIzaN/IkexYCa7dD6D3fy92+cqpG7rK3kD17
nNIQQm/6TD8q5DlUO0POiveRn3RAMkCUmCMULl6C4pMA5Kcni9lyHUJueF8/VnZ6vrYUy3eclNqK3ahy
wAiSqNCT7+6CWzrX0w/4hsLhXVGbX/llL7LlPjGEtecY0SWFLjo6DEsf6YPWPoTC+8sPYuxnayRudBPD
HNVGmFirijCaJ6p9WQtKYYHg0AVCLf0K78wSjeD6D1aqhkO376T6L99+fdcGeOHqlmhYtfhh6dTUbv18
LXZTU/NsXBRBGiHaxfon+6NJtQj9oEV5w3qwEBx56FTCoBKLnVu5INqcBPMR7wR1vRuBjXrAsXmWNm7B
QLQGe6dbRcv4CUG9H9LGMmRKJvBhvbi/29iXcIVHw7FlNpw0Q8qJViygVHGNAqg+Xt4oZkBTPzNiXFQo
npNCsOChnogVTUJpBuZIFJX5vJgrIz9di3Sq0l6Ij5N3BUkBM27iD8PFXyNsgdofd01ZjzNUu8sVvsgI
sHfWHU7GqI9/U3LJTRjwQI4Dz17XBl/f3dkvYUAS6sXg5wd7Ii62gmYuGPC5Yk5cFKH195lbtGMWfwiF
BEJ+1kVVs8POrkKKAw0jDzJ1VOOiaRCST8QcUN2S8mfOL/+WDO2eaQMqVkbwoAkIvetb1SPB3gs1GEng
e43NeHehsIiGEhBoR86S1+UFGfrBsqFse88XElGD2UVWEno2roJPbk3QCoj5Q4gIhV0HzuDjFYf0A+6E
UxiwwOthCBHzpLKYLEooEONZEt7jJ1Nx97SN+oEy4BZG/mEOsDsUZLeIIMqRmls1gprJyMUDVzTDhKHN
9QP+Uyc2HE9dKfdRiJrjn4jZsGD7Sew8kaofsChvCpVqzk1Q3YRi3xvpUejXH2GgE9i0PwLbjoDzwK/I
XTNFP+qOrUZL1fgYetPn6u/8jHMSkGx1zsiSnnnDFZagcOQlblYTq8oDtgkovLzQ85A/XN2mJga3E7Wb
trGB8SC7HZ+u/l3KeOEnuwkf0VCopEwa0Rq1q0jtma3XnryNW4UQfC/PeWeZmF9lga90BcV4uHfelXft
OXCWkqvgMt4vAqJ5w8p4ZXhr7VgpuL59bdjFPAB7KWjCZMjGXzFB8s6k4av1R/UrLcob95IthdCxaYbU
7NqEIqavsTHN+UuMX38J7veoavij5sFRjr4IjB+IsHvmIHjYRGUOIOM88vMKVEdvYVHtGPYQETaTxW6V
TFNGXE0qxstMeOz6zfA2tMPluXy0/nj1KzXrnlMXcJANkB4YlxnkiArdUVTqj0Z1EI1DtAQKESOM3ILt
GD9jM7YmpvDysuMZABPnpYC+tnifZiYQI2J4j8Tfs1LDU6MpLZVFGEy+uSNevrkDXrvJfXvprk7oeVlV
/UqL8sYt1Rx7l6juwYBgreWfqDSWrbSFgdjimiK47yPIS9qnqfdFIaYK2x7CxvwAe+c7JOM71ahII4d6
5lMVLtFmnMe3wnmkHNRmPtHzJWWkdc1K1PnlufJgBtiITPl1SI165JxmJhVHstSSA5vH4e5+TYA0EX7m
cEoBzBIt5JbJ61SPSdkxB9Sd+aK2nzl9sbCpkONA07oxuKp12eecjOpUF+MHNsM/+jdx2/5vcDz6x1fT
r7Iob9wEgnP3z5LJtDkIZrxnC/+hCZCXfBgBFavAsXGGUvGLIyC6NkKufglhd87U/CNkilDIzXQLC8uD
KhMcTu3IgXPXPO6VDaMcGIXNXOhKSeXIENiDJao9n0XtRmr7lHSTOVEEhvLyhpgO8RxBaJghPM5N1Pet
e89g/Oxt6nCZKCLRp68/5n7e+C5HHoa1qgG73thpcenhEgj52WnIO7JB1bZqX9/MeO77RZ4D2TPGwrH2
C6lRKrJKRM7Cl/WTxWOr2xGhd8xQIyPpRIXjItRoRcmRWrbTQyXhduxfroRG2dCfx4ebP1j2S/X9glPU
e6MwF3qIPLekBShcVPUvbrscQRzIw9GWxHhEeDDeWbAHc7ae0A/4CcPlFrZCBxQ0F9YfPSfxLe82n2Yw
7Db0bmKp85cyLoGQl7gFeeeOqFGJRt4yfr1nDf9wbPgajt2/qB4F9ZTQSDj3LYFj6xztAj/hMOlQdlP2
+QcC7MGubkpDLHCQVH7qcTFLDmr7pcX8oeZyKsfNuyXhaHIGnGyNZ2ybI5dSIjAQVSILTDR/6VA3Gi8O
b6MGELlg2Clc5P8xX27AiZQSCEeGxwhbERxKSscZNvaZhRj/FM2SoxCbsbvU4pKlQCCc3Kk1yokay3yl
0lid0TDGIyjMLeBFwIFDOcveRABnPup3qwIshTd3yRtKKykJAeGVEHzF4wi9ew7sLa+U+y8iX7QFPjPA
Jvas7OedLWNLuy8k2Ob4KAmrDp3VutGMhxgPEs0hMiIETfzsp/dkXP/GGHx5Pa0FnhjJIhrE6dMXcKcI
hdLDhxkPLICTltiToPKAcZrf48xH9cgwxJVCuFn891BgMoiNb6Swkc78NTbXUVWreYwi84HyqMS2A336
s/4EMR3CRQDtgGPVx/qBkmGLa4aQUZ8ieNiLWnhU74I8XezxvBMi2MqCWdgxoxu78rfpjN+wv/7zVRK3
auKUftAgKxd9RcWuWoZC9MlNHVCtqtTK5gFODHeFEMxfdwSvLtqrHSsn9p25SBtI2+F7uBE5VrliMEKs
SUiXNAUaQupJ2dN2zelcWjiWwbF2ipgIEYWep8qFHM/57WM1Z6K0BHW+TTU8UktQ/hw54jFpv362tOgh
NQJs/JZGGgj3TNuIg8fEvDFa5PkcbixU7Cpkj0EZqB4Vio9Hd9TCyeHCxHhHaBCenLUV63+X95cYPsv4
+AI4Ecv1fG5E/w317HWwuOQo0BBok+sDjox0NiicLYon55eX1ahH+kDwhppBefGMMh3Kgr39DbC3vkYz
P0SgcWp2maCDA2JkeCMyShgJ+09fxDXvr8K0Xw+qhj638sUxBGk5eOLKFujcsOwz+K5sVR0PDWqmDeAx
4LvsNjWS8NYv1iHNxxBpn/j4Xvo0cJu8ZMLVcGpxyaKrBFJb5WZL5i/QEJjkRvqWtEw49yyEc9fPyimK
ca/xS1zPCasEx+Zv4Ty0Sj9QOpRfBrYhCPTczLELpcYcUA8i2KpfBGzE+2nbSdw1dT3aT/wFc9aI9sOR
fHymsbFgZuTifhEGL1zVgreVC/++phXaNatWIBT4LkZ0WBB2HUjCuG+3qsM+8UxcH/GQbWghBj6us7g0
cWkIxMhDRhobv0YW8CvtHTnIWfSqXCxX6/a4+T7j+eqZFEBSeHN5vepKLB0BYZHyj66uUhjQfCg1EjLj
g4kWUFUrTvhhJ/4+Ywse+GoTHvx6M8ZO34TRk9dh8Nsr0Ob5hWq24NBJy/DJon24yJqUzlD4sdQIKAgu
ZqN2bAV8ek8XvH1DWz643KBnocm3JCCsQkjhrkgJx0cL9+Ib+irwhTmRikANQGSccDPu0f+mwxeLSxs3
gWBOYzN+5hVF7prPkXdsk+pZ8IbxLP6qLTQCzoMr1azF0pK75gspdBQo8sRAEQy6tlBqGDBzpte3masP
Y9JPO/DO/N14e94uvP/zbkxduh/zNx7F1kPJSOWMQ5aYYNEk2EbA1n+OKBSB0LpeDF4e1QGbJlyB27vW
lweWPy1rRuH160XQUPiYw687dBn75QYcSS5iEhivL4ZKnBZuPNdAxY8NqaKdOIwGR4tLEk0gcKQfByTR
dCgDnKeQu+J9N2Fg5MsiYTckBy6VkLxTu5A94341/0LzwJSvOXMxtIWyYmR645cFiw2v7INXfxubHNM1
oiB7IGKjQtG2QWXc2KOhCIH2WPNYP2x+agDGD2yqxun/kYyRd47o1kAEEU1AOWAkQHAgks+l43YxZ/xC
taVwc6dmjMSvt8YCiRM6O0nNLGFbhcV/FQUaQoUYTd02YSR7sQVaJ2fpJOSdP4Z8u5bpjfuMbKXta94U
3GADY3oy8lNPqnkL+Zmmjfs8d+4o8o5vU67g6XEp+4ublZs2x+aZaik49RYJP8cqlAkGzjOALACyPXtt
a0y7rxu+vFe2sd0wVTb+zry/O+Y93BOrpeBvf3oA9j4zEJue7I/pd3TC+Cua4vIGsSIrCheuP4r3R7ZD
bfp1UOMF5AA3flN4MJZsPIaJouEUolCieIsIaD4hRNsodFq+75wIoVOpZR0pavGfxCUQbFE1JIHdNQTP
LFw4exRAN+yOjV9rmgYHDHHNBk5hzs1SDX2qsU/9uh/jply1XzyDzPcGIfONHrJ1L9he528PZEzqhcy3
+iLrk+uQM/95OPYuRj79O4ZFydv1kIpAsFUtWzeeqwAZhYjomf/6drUxsmMdjErQtpv4K/sj2tXCoJbV
lbfgJnGRiP2DtYDioBbyCbsiqb2YGwH5TWFBmDBnO34TE8cN45sNzH+buKxqRdiU2SDPNV8j73Jm5mKf
l5mbFpcOLoEQEOvdrmV2MtLdlf4emgTJXfQKcDFJjSQM7vMP2Ko1Vour2Co3kK2+afPcr48AORYQU0fU
Wi4JJxsXf2Wtz196e46oqlaH5joQQYMnIDD+Cu0afdyEhoTUFoiA6iV3yuETj0KRSndolwgDmlXDY3Q0
wl4HQybwV2p3Z45DuSq7YEyOIjxnXKfgx3tEgNCwSkVUr6Q7anG7XhDhQzdoFpcuLp+KziPrkfXxcDVP
wOh+9AY9GgXW66S8HBk4tn2P7M9Hwta4F8LG/Cj3S0bKk9pbOTkpnKlKBBsIDRMk9QRylr0F5/YfNC3D
3HhIISX7nDZtq1Z6LeFJqT0nzt5K10n6EYG9BMLa/+uHhPr0MfnHs+H38+j4ksntnARh1aN90aUE4xbo
XbrXa8vw286T8j2SrlQAmRz8HFHvb+nXBJNvEU1CKIlPxes+Wo1Zqw5pvShmRMB0aV4dqx6xVte6VHGV
/MAaLVVNne/IcasstL+NPS+IecAVm9gOQHdpShgQullj46Je05d6ozDIzUTu0jeR+c4AOFZ/KmHMdgkD
vk290ZkDm2gZNh+ajt8Y8sscCaSIKPhDKcN76dn4cynwUXS9ZvgoNJ4nhfmLpfvw5TrN+1Dh1/CI95ff
0KG2ls6ep4PtWC+myN5TF/UDFpcaBapAUCjs9S6XWl1sfcEoF8avL3J++wzOg6tgTxiFwIbd9aPlh0O0
gcz3BiPn5+dF+Ih9GhYtedFWIAgMRGMIbNxHBIhHrVVeyMuKi4s/hDK+tHG1CLxxYztNIJh7B9i+YA/E
/dM2KO0gKjTIo/OAL/b+8n5ijlTl/AlPRyyBAchNy8LUtUf0AxaXGm62QWBzrqOgNxgJ/JcbZxOa84rx
d37KcTiWvye1cj0E9X5YP1o+sEche8poZE+/G/ln9iuXavn61GwjXC7YGBoUBnv8IP1AWTAVAo/y4PbO
S4jbOtfDTb0u08ZFGN/EjwkOROr5TNwxdaPyssTFU/whKiwI93ZvoI138CTEjs/EnKDfBItLD3eB0LAb
bLXaSG1SMHjFWx1hiAc1CClpP+xd7oRNX4ilrORfPI2cn57RuhR3LZAMVlEzHQRvYSGqXaNugoS99I49
XZhLPf829s3HL0HevaEtGtWL0bwsmSNSTIeFWxLx6LfbEFrUojAejO3ZELHUEsymCLegQJw8dQHPzfPS
tWnxX497lSB2eVDHkcoeZ9oybxSUA7Yk6Hs2O/LOHdUWda3eHEFd7tCOl4U8hxqclPn+UG3aNLUUdima
+u/5diNcBipMeU4RSrfJCf9quCIJ0L+R8EXGy+TX/N5LDa6qzKHNgZyezB4C03dxybgvVh/GqQuZkrZ6
HJqiwRucsv0c52IYoyL5HOOZYcF4a8Ee/LL7tH7A4lKhUAli157SEmivCwX5xpTiop47t89FXvIhNbGI
3YJlwbl3idIIcmY/ojQEiHnA9RaMNzK/mfOc8bciKw2BDbrA3nSAfqCcMF5kIH+bd/9UyunFXMn5mWta
aVqC+ZkUuoE21QlRELHFM0bMhoEJdaFGRRI+k1tgAJx5eRj18WpsSbTWULiUKFyl2kMQ3HecJGye1NIq
i7gRoLsqc2z6RrlWpwApLXmn9qiVorOm3Azn0Y2aIFALxBTkV+PXnE9dfysfCDYE9R0vmTBIP1hG3AqK
/ktKUFDKnXJ891ODmqF3u9oFXpYM+A6jQBM/3snRl+zFaFiHLvM92idC7Eg6n4Er3lhmaQqXEF51bK6P
YG97nSQyffx75IzAYOSfO4K8M/ukZu6mvBeVlPz0c8hZMFG0gqvh2PKtNhjJYzVo460FeaygpBp/5Uv4
7JffgsCGXfUj5Yy5gBS8/pLn89EdERMbXmD/E36fH0LAE7pMm3Nfd1SvIulnNFoazxEz5YwIhYGTfsXj
322zGhovAXwa3cFD/omAao2V30Ijhfmvq4xwmHDtEk7hlXty101F5vtD1PoMHE8QECa1i9j+5vLmeof+
q+UxLQxqX2omOl+x1WqL4P6PqeN/CNqLNYzf/wHqijD44KYOYquJBqgPulIYkU1Mh4ujRY1ILBrXG83Z
aHlBzAdz/2WoXZkiL4lAaP38Qvxz7g5sP15yM4IrRe+Q+95cuFctMGvxx+BzOXiiRi9+dr1kGoeo8nTP
rl2qamspkCE3fAB766vVseKgp+WcJZOQ9/sabbARtQL9HOGTPfdJ4XIowiA3QyRWRbVmg61G+TkZIU9+
vx0T6UyEfgWMl1+iIxWLY8z0jfiQE50iTKMyCT+3iJGKvuBCMg9+tQnTVx6SqkYijys7MQ6NxKVGkuOA
rWII2omZwQVs4qtHol5MOKqJphEm1/OyTLkm6WI2jqVkKs9TB5LSXFue7N97bRu8N6qdXGlR3hQpEIhz
2/fImjFWKnGx0fVBP0ogZKch9JapCGzSTx3zRd6p3crzsnP7T5pgCY3Qz2gYecX4Jea/iRFAdZ0aOBWA
0Js+LfbdpUEJhFmmoct8KQWC/L/2sf8tgZAuBS/hxcXYdThZ8+xkRDx/s3Lxzf0UCLV5aYlgDf7cTzux
jd6m+Sx6mjJ6L4z4pHAwfCfog6Rcrt05IYs9IVyyjvfzOBs+efpCFu69upUIhPbqUovyxafJYBDY6iqE
DH8D+VKY1YxFSRWlvov6n5fk2+V5floScuY/p9oJnFtmIyAoxCUMmMYGehZwYT5n/M1r1OAoagbyy0Vb
DGFA00H1TJQTGVxIla3m6frGv/V9p6f7sD8QtQCs8X7911HO768QbMcXt3aEjc5RUyRt3b45R5QEvcCW
kBGiVazn9O+x3XFF21qq5nct2MoeDj6X8yV4nJvy1CzfxuMc/agEhewbmYNxYbehWmwFDOhUH0Nb1dBP
WJQ3xWoIBuxmzJ49TjkzDQiJVDW1rVIthIz8ELbqBWp7fkqiGm7sWDMZeWcPyrUiBOjvQBJYexH/NVoE
fKNdpf0qsi4gIDxGhMFbmjAQ4URnLPSVwPET+bmZCLp8tFtYSsOqA2dlS4Ld5E6cMcSwcOpzXNSfs+7A
aakJp6076hYPN3aogxqVyv/983eewvZj5wu+WV7mlEJ5VZuaauhzWTl0Nh2/MV4PJWPHiVT1bSmigWQb
Q58Zv6IBcKQkF4mtIAIqKiwYNcSM4OzK+LhIZVo0jotAjOeEKotyxW+BQPKObhCh8A/kndglKmYlyTU5
qnfAVjdBNQ7mXzihuhLVCs9ci8Ee4srQxPwi7VjBWfN1bogmkp+ZAlvtdqKpTIKtRnN1mNoHstOlmosW
c0Zsz0o11MjGkMHPICC2nrrG4r8Tah5pIhAyTb0ctAhCxGzgug6hIhiC/BxGbVG+lEggEK6tmPPzc2rR
VjWHwC41Fu162nucgShCgGMV1LWysZAXFgSFKSQQJFiqh0O0i6DLb0bQgMc0bUOgz0ZOuba3uw7Zc+R4
ZBwC6yWoac95xzaX+7wKC4u/CiUWw5xkFHLt66pB0Vano6juusus0Ioi4mXjwCXtiAsWdKOw85z5fKG/
qRHQbVpOmppbEXrbVwi+8gWXMCB0p2ar3FC0kHDVuJmfdga2qJpiLrSUv8/qV1lYWJSUUutlnGocds8c
hIz8SA1QUhpCxjnR5TMQQOcoPjALBw3RBHh9jqj/cj9bGgIb90boqM8Qeucsr4OOuFQ82ycoDAIq1URg
7fbIS9qn1qfUFpW1sLAoDSU2GXyRl7gZjh3z4Dy8WiusXLZdans14Uh1OclGScDXqU0ECDcxMwIqxKoa
3yYagb35INhqtFTP9IncnzP/WdXAGdiwB2xVGigTIj/pEIIGPVV2JykWFn9Ryk0guJDHcb3GvBM7kH96
D/JSErXl1TilmpoA2xdE1ad35IBKtWGLa6J6BmwxdfUH+AeduNIXQ35GsnxFoPL0FJRwE2w1W+lXWFhY
lJTyFwh/MmxvYDtGQEQ1/YiFhUVpueQFgoWFRflhCQRhwc5T2HsiFRHhwQjVB+dwYE7liBAMbFEdP2w5
gSPJaagYGoRge6DWKCr/OHKdSGhUGU38GLxz7FwGluw6jcqRIRjSqgbmbj2O48kZ6p2BtgD1viqRobii
eZx+R/FkZDvkOSeUd+W2daKx9nAy8vLyER5ih40d+0xZ/tCM85LKvITXhAUHqtF/3lyo7T+ThtUHz2J/
UhouZDnUPfSsFFMhCNUlvC1qVkLb2triOBzUdUiut9sD3N7H17iGoskPw2jaVee4BFynhrEIk/j/blOi
Gt3IcKnvEBg/MZIegyU9/OVUahYW7zoFm82m/DNwvQyun/Hd5kScPJ+JiLAg2Dli0kDiydtgUBVGhltO
9m5WTa178flvh+WoxHWwXTmzZTyyQZz+dYa0qYFIrl1RDBt+P4ftR8+jRe1odKwfg8NJ6Vi5P0niz6bS
zFUy5d1aKOUP+d91jgFTPxLf8n1GfjVzQE+/fSr96HY/QOLYhhjJd0y/ZtUj0b5ejPEoSyCQtxbvx/eb
jmFNYgoyzqVr4+qlsDVqWBn7nxuMVxbsxbcbjmLLyQvITuHEKrvKPByP30Aic8MT/RFdzAi6b9YfxfUv
LkLNJlVxbOJQPD9vF75cdRj7jnEZfiZHPmwVQnBQ3levsvd1MT35cPlBjHlrOcJqROHXf/TCG4v3YeW+
JBzjbEIplJoHKQknRwRyzUtipDzDz+NSOANjK+DoC0NQg+st6Bw+m46n52zH1xJu53n5Zs5HYLxIwVTz
EByyyf1tL6+HTY9rw8j7T/oVi1hQODeBG79LvU/+UavE6hgDkniOwoE5UJ779KgOGJVQFw99tQk7z1xE
4vEUead+H0tqeBAOSPxw9KI//GPmFrwhm3IXL+lZv0FlFb+cZzFz3VHskPTmZCuVnkSNnJRAce4Ew8Tw
6WFTmyMPn4/rhRvb18YdUzdgq6TdjqP6Mxg3vFiE5g39GuOrOzrJftHcMWU9Pvt6M0b/rQ2+uDUB7yzZ
jwc+XKWlFdOHcWjA4eUMEA/p6eaCYRMaNKqCvc8OVELuiFRAXJBn2tojcMrfKv34DA4P5/B8J7c81GsW
h/3/Giz3aO+yBIKJkymZ6CuZejcLqcRKy3qx2PJUf6lhtMg6cyFLrfa8QGoYbSafHE/Lxo29L8P02y9X
1/hittR6w19dikaXVcbOp69w1cbT1h7FzZ+uRj6flZGDx4e3xsSri+llEZySIdpNXIRt2xIx9prWeJee
lQXWtJ+IoOHCruqZsv/Y0Oa4tk1NV/7mb54k+9FzmWoy18HTF7FPCkqDqlpB41DjPq8txZFDZ1ExLhIT
5P4+jasiSgokRxceEwGxRQrT9xuOwSaFafWjfdR9veSeX0XzGTsoHgPiq6mak0OS98nzH56xSV4KRErt
+v6NbVFJaiiGI0OeN12Ezuyl+3HvVa3wnpwjnO48TgrzOwv26HGtLsaTI9rg+WHFD09PFwHQ5Jmfcfz0
BblfamsptPF1Y7D1yQGuzL/xyHkM//A3HBHhw27zPq1q4pkh8arWZ/xoVwHnM3MxefXvmL5wDybd1QUP
9b1MPwNsO5aCoe+uxDHRINX8DCLXfyzX3dmt6N4urh7+/rdbcde1rfDRqPZ4af4ePD55Lbp2rIP7ezZU
8c3SybgYK0LyJCsrSffHrmyBno2rKE2L+WCjaBkT5+5ATUm/Q5KOpySfdnl5CX4/kIRw0V7/ObQF+kpF
xOdlSXzTyzY9Wf0o+fisCLBtTw9w5UeT2LbgikRdRcqq5dQlN7A8maEfwb9x9p/UVgEUEpTMUvt89esB
lWGKhc/U/zQYdXkdXEUPRlTnQgLx5bojbkN6fbF0zxlskwQPjKmAsT0a6kdZUdlwS6d6iJawqvDJ/o2S
wTqKJtNBNuM3oX6smoQ0bkATOJPTcSGb6qTGMz/sxBFRZ21RYfj6zs4Y378J2teNRiOpmbnCNNX2JwY2
w9qnBmCaCEKjRjkianhDeTaF01Wta6rrBokJNJhmEC+S3B0qmsLwNrW0c7INb1cLU6R25BTs01w9W4cZ
9Jq2tVSERUkcqwlSUgvP2HjMrxWmf9x+EsfFDKwUHV5Q+7n+0eA39RfBpWpcSfP+Yg50v6yKOm7EEzce
f/NvIqgkzWn6mWkl5lIXMRt5P00TVYJFoPz9643YU8z6FEZQjN+TafL98o7JozviBkmzQc2rq3i6WoS5
MkGoFcjWQ8I4MF7iVc5dKabeMyKwu0gYE6VCoxijg9vfDyXDFhmGryT9HpU0NtKvhaQfzYrHBjbFStHs
5o7tKq8siBRLIHjCBFW/2o8nSlsQdTlBapthkrHVgqqiij341UZVE5aGf/SRGodtF5Lhj0km/la0ieJ4
W4QQZyYOkMRtLolsJkvCx3YJgwyqtD7oLTX/QyNau9aj5LVL959RwilaBKQqMEXQQMwb40015forJKN6
clFqa+MiRq9myxZQQQp7r/jqiGahNxFEs0cKf+taUejEaedy8wGpkRfuKn5262cU0JLRb2hfR2kpvtKT
bUIKuYSu6H1RKSwIj4pQ6CoanieckEWt4M6u9dGCi+yKtpEmmuOtX6wrXngZkSdUkDwQLyo849EMJ4FR
YzHgtHVPeoqQaFI1AqdEKPy885TKk1ViwzFU8kdRcPKaITCJJRA8cEW7KaHMqIQRKc0JOFTzasRFqP2L
F7JxyxfrlQpXUrqL+teRmokqOAH4kMukFQGdhszfdkJs6mBRLQu7v2cQTfmnSLh466Qb2qG21KSE6mkW
NST5vtTULKwvwVqNix7qgTev8+FFq5jwLHigO9718HGgbpH45DoQt3UW9ZsHpIB9rBr0fLNfTIDFEj9N
G8RILRqHXMYr8ZKmKj39iCsWmn+LKXeN1NaeqLiWQttKBPOnN2tL49FMWbvzJJ4UbctfWNNveqKfakwt
KRMGx2OD1Pihcq8SwCLozolpwBmmJcESCJ4wcX0IAzNp2U5UiwrFJ8wAvCfUjjXbT+DpucVkAB/Pvr+X
FGwKE6klf9t3psiC+P6KQ8gVNT9eVNWS9Ep4ciI1E99tPq61+utw2nETtiWIUGDtNvqztX4v4MoeGnNt
40YxcaqmPut2rAs9WIzra8QEiWFjq5hAi3efwnExT3wxZc0RMYPScHPHuqgVLbWtuZYu+NQCXGHzHkgK
jW/F3ua0bZ/IrecycpAgJsbfB8Wr9g4p2Xj5x51+aTTEaxz4CTVCxj8bt1Wvl9MpMioft0r6rT3sv1C3
BIInxWRcA8Psoo380KBmmvOP8CC89OMOLBH73iu8x1uGFIa3rYmaNUT1lxo6T9TPD1Yc1M+4kyrnpq07
ogrGmG4N3EwDX4QZregefLTyMEZ9vlZeWRAofte4/vpiufLsQ6cuoMfLi/H3bzaX2iQqNfqnUWWuKAJ3
CNVfiZ+LYsd/scZ7mw2nVk9df5SSTfVYZDt8RLgnclkwTRQvsOtuxFvLsbuYNgFDK3tJNIn2YtMrjU8O
sjfhLJ3O/AnwC54c2FT7i+l3WtLvlcV46OvNfq25aQkET5iofuYhg5evaYV2KgM4Jf3zcbvYjslpIiA8
KeK5tKPv6CJqMRsURd38fstx5VfQk+nrjuJMYgpiRHgww/vEyNvyu+XYeWxPTMXmo+fl7xRsPHIOn646
jDcX7FF90Z7FgGrxyzeJ5sOuPqldWcgm/bQLbZ9bgNGfrsWK/Un6lX8wenwZ0UYbXbW1iDD8ZlOi1+hc
JLXxkQNn0bl5deVMtqj2E4XxENFsjiRnKEeuKp7UloKftp/EnVM3yHX5aoxEkegRyZp+yq2XI5wrbktY
E0+kYMz0TdpJM54RX06wsfYN0VwDKOgl/XJE23trnpZ+oz5Zg+X7fKefJRBKiyk3MgN8cUsCwtjfLRng
yPEU3PvVRv2s/9whGT6UHpkkVZKlVvKsBVkDqfYFKaAjE+oU7z2I1b3UErd+vBqtnp6HdhPmo+2Eeegg
v3e+9StSzqf7zOTj+zfGovF90KWJCDoKKXkW3ctNXX4APf69GFe9uxKbRbiUBm8F2R86N4hFo1raal5b
D53F4j2FVfFPVh9W9vztnTQnOcW26RiFUuLyo2UH0JLx9E+JJ24SV0Mn/oIV7GYOlbgurgCbXhVfIxKv
X99O0xLCg/GtpNsHYuq5wetLExl+3PNw38uwhD44m4pJycZSyQd0XjtdNM+eovENe2eF6q70xBIInpRS
arM757Xr22q9DpIBZq48pFTyklAnJhwj2tUCMuUZUlCnijZgtu9/Edt5q9TOgXLdvd0Luhp9I/fK/RNE
hZ02pgum3NMFU+/ugs/k97Eb2iEsIlTV/r7o27QqVj3eDzMf6I4+LenHUA+L1KZzxWzpKoXlg+XeTZtC
mDKx31HscSHHNdxyuWhFDLNkcs9Vptkl+PPW46goaXFVGx9+F329XOL86va1MV3i5guJoync7umKV+/o
hBZNqopQdO8Z8Yd7ujfAcDHrVHtCcCAembEJO09c0M/qlCa/+XlPr8ZVsOqxvpj1YA/0ay3xwQqC90r6
/SBmFdPvbRGCZiyB4Ikf0tdXgtzboyGuVRlAMo9kgHGSAXaf1DKAeqwfCal6DdjKLAJh28GzWheSzju/
SuETW3RAy+qqBioSvlDfru9QByOlIN3MVaBlu01MkxfFzBnTpzESUzKK/eQRUlAWj+uFX8f3xTWseVkg
xcTJlN97P12Dr9cf068sAj8zcXFwHIidqrjEzw/bTqjBYgZfigDNEjt5eLvaqGL2mm3G18eKgOlUPxY3
SjyNljhiXN3cuS7G9WuMKbclqG8uqlvSFx/c2A61a7ArMh/pYkbeJuYkh5qXieISzAOO9fjl772wQjS+
4ZdL+tEUlDyWLWF68PO1ynengSUQPCljxv1wZDvUYmGVyE6TzHrblPXquGo99iMhOWCom9EgJRlH9acL
bBBaqHc1PsCl3YvD9B2cg+CNm8TsuEuEg+qn94MeUuPMvrcrvh7TDRU5ZoC3SW3z5Nwdfg2mKjFe4ov9
5r1pxkimPp+UhhkbtTEb7AmYtl40BokfLn/vwvwM/u3rU+V4Zq73eGpePQpjBsYXCJkSwHkPn93aUZ4v
L5A4W7/rFJ74foc652e0lxvdLquCWZJ+30j6RYbp5qZoXY/N2YaL+tgQSyB44kehVfhITJUBbpEahYQG
Ye2Ok3hl4V5EcvisHzCTPMguSBJqxw9bjqtJOhzBmJ2cjqYNK6OfqPIlw/tHcbGUt6QGC/LVVeiD6zvW
xjsj2yuBhSC7asnepWtCfwa3s/GVSGbmsGfChrKde5PQRDJ9V/PaFeZP49/+pq8JthG9L4Kenp9LQ7+m
1fDElS0000EE1qvzdmH1oWTEsg2oKCHli5Je78F1HWrh3VH6yl2iaSWeTXf1oFgCoTQUk6k41JXjzbUM
EIQJP+7EZDYQcoKJHwwRe70+ZxA68pEjknuC1MCz2LAlBeB+MUvU7Lr/MBwyG8URdXSdJ9pQsa35JkpR
Jt3g6MnKnOAk8bBm/xnsErtcxU+mqOSi8rvNYPwv4dmh8ejCdhgOEZcIuGPqemzjytjmSV9/Ile3roHK
MRU0oSDalaHhWQLBkzJKX4N/XdkcnVUGcCBLNjVdVqp/f9TzcLHvxnRrqLUOixD5eOUh7Dl6HtFiilzP
uRQlpuh3PjhjM27+bK2+5x+0p3PZliDCIFSEXr1Y/2ZolggfwWbNemMHiQdmYgnC46LyztlyAkEiJEqz
0pS/cIBRwgu/4IS3QVHFSDkKKa6UHREpQtQWgN3HUzFn63GqHyWXkGWVqEKmpF8O85cIgyDRXtmgTSyB
4Akj2x+hUEyisBb/bLRkgAh9kpFkgpIk5MiE2qjIUXYsdLxXEo+TljjnvaQoe78IPl11CIc5xVlg1yYH
IJkHK3njExFwGWzQEw3mqpY1UVvPUOVKEUFQglE1vtowV8yq48dTMKh1TTSoUkrBJO8yfGH4YuamRKzn
hDJPE4u7fuQZtn/QRFPTpZmm3PzFz3ewLYUaU3Hp9+GKg7iQKoIty6HmO9TXp9xbAsEbelwWFaX5fiRO
07gIvHmj2Nq6JCb6T7HUig7HTWwRzhQVUxLXFhasDVzyE9d7RBjN2HAUGw6fU4NtNh/Rtq1HU7By/1k8
8PVmZIgN2UCv4anA3D11A9pMmI9Hv92K2aKKs0GTrflsy+A9Y6ZtxD+5IK5kpuaNq+LVEa3VvUXiR5z6
wts9nRrEol3DylrjKwuWCODR7JIsAhUnvtJNhMHiPWeUgxLGjRFPjDPG3UcrDmH66sOoKlpIuKfg4HP9
/LBb2dPDRmFj6Xw/UWH34x3UQNmQzfQbL2nEiXLs6XKl34GzuFfS7+lvt6n0i29UBW+zu1zHEggeZLDw
0vaXLY2ZzQNO/lHnfLTce3Jbl3oYyUbCFJHGJbiP3C73KgchyekYJDY7xzr4AzOPmlHId0l4n/96Ezpy
oI0anCSb/LZ5+id0f/ZnvCPqNlXvUJPdzR6RnXtO45WvNmH4xEVo+tgPqPZ/c1H9ke/R/Z/z8OHcHYiq
EIL7h7XAsnG9tfkCReBkgCjYMnJVuFzCqhhULSdxRt8GnnDI9k0d62gFSzJ7laoVlQ8GT4xnuNLT493K
duZ5CdSidUfQ/ZmfVdyoeJKNcca4u+fdFchISldxwwlEZujTgc/wt1vy7evboFHdGFeeUHmuGFQvgP4d
uWy38QFlDAebMf1elfQb8dIixDP9HpX0Gy/pJ9/0gaRfpJh59w1tjmWP9EZNU/pZDlI8YOvvXpGorClj
KoZgaMsa6m8DLkm+fPdpVJMafEhL/9x5pUhBoMs0RjXn9g+Twm2eg14Uc7aewHlR7bo3q6bms/sDBxt9
L+9jZld+GySFVaH0gEGwSRbKk+tb1412uUI7IgKIA2joCOW4ZFo6jknNdKCSZKK6okk0rx6pVsE2e1gq
inNSaH/cdkKVRc7k4/cXp54TTiaaJ/fFSVxzzognyWnZ+GnHSRX+RnGR6Ea/BB6clFpx4c6T6u9oSc8r
PdJzjdT+e06kwqZ3C1Pl9lYgKIDyRduKFRNwqEe6rzx4FnsTU9SMVc549Af6Slgj5geLcNOakWoMhC84
2pJjLlIpEIReTauhbhEmGodg7zqZiqPnJP0k75w8n6XmwHAKd53K4Vr61Yt1EwQGlkCwsLBwYZkMFhYW
LiyBYGFh4cISCBYWFi4sgWBhYeHCEggWFhYuLIFgYWHhwhIIFpcs7DAvr2nXasCZhTUOwRtcJYcLktDh
iRnOY68eEYIHuI5CGeHEoIdnbsGjVzQtcpBJSeAgm/HfbEZYqF0NrnHKO2rHVMAXtyXg1V/2okZUKEYm
1MXaQ8l4eeFeTL+zk+anQaD/xnHfblULkkSHB+HJOduxYs9phIUHIzfXiUphwXj9b23clpmjCzUuScdl
yzhFuLzhoKInvt+uhtZ6zsfgsnXfbTimRldxjcanhsQrF2s7T6Ti3WUH8B6nZwu3T1mPQ6cvIjjYrr4j
vkYUXh7eSvmwJG8u2a+WdWMxaFUnGq9f16ZUbtD/V7A0BC9sOpqCZ3/YqTKJAZ2m0qMyR4GVBxwRt0YK
ZlEuzEoKR1HmSpBfvba1cvz6yvDWInA0D8pbpfAeSkpXf6dLrTp74R5VmA3o/WjFgbOumnLVwbNqRNyr
8oxXR7RRq1rRQ7O5JuXoy9lSMHntHwHdwHMBWboTNzN783G8I4X+3yNa43MRdlzWjMvPEY4K5WhTQvdz
G46cx10i2F+T73jh6pY4cOYiHpixWZ1/f/lBTBKBMPHaVvj41gS1nsOoz9YozeOviiUQvFCjUihOS8Hn
cFEDOijJF6EQXaHA0YlDMuqS3adVrWTAaaWs2bhY6uJdp9Q+YSZdfdB90Qyub8jht0ulJuYwYTMcavrL
zlNq+KkB5wGwJudklRX7zhQa488hufQ0zOXFuBo0V/VtTtfuAocKG7U4C1p8y+pq/QIKP8J7WQsbw3pD
7IHynGilKbWrG413R7ZTYeJaDoTj9n+Tbxo9KB4zWFP7gMOeF+w4qbw9G1CocFgyh0Uvkjji0GYzjD/G
Ca+JljgyDzUmy/aeUbMdOzesrBZ+pZY1KqGOOschxkbtT/hN9ELVslaUWnLtzRvbyTdrzkUpWOingJ6g
6Pzkm7u6IFBelqIPEf4rYgkEL9htNlzXuS4+1p2k0gfej9tPoFfHOsjmqkYCM82w91bi7cX7cevk9Xhj
0T51nMuht39hIcZM34jXRC0f+NZy3Dl1PZ7/aRce+GqjcunNGojToznRide9Kc/o+foyrNiv1bR7RcXt
/+ZyfPTrAQx5d6Va8p0sl/Ntn/kZT83dgUdnblWu2s2w3EhQi4VCqr0UEq75d/e0DeqYnXMeTHDPPFmH
cypYU3MZcUJtglrOS9e0VLUwhYUnNCmGShx9svIQ7pE4eGTWVnU8SYQgFyO9+fN1eEvirfsrS7BDF6pc
FKb7q0skTvbhHomb85k5CPIIW2sReLM2JWKTvNfrhCJTDc87Q0zzJnbJewzByPUealcqMNdiKgZj5j1d
1JyNvyqWQPDCxexc3NChDlKlRuYkHzo6ja0QgkHxca519d779aCa6PPd/d2wdFwvfL76d5yR2psZkAJl
8i0JmPdwT+W/gKr8Tw90x6+P9pGClIStiSlqjcjzIlQe6NUIc+7rppyrvrhgt3r2Sz/vwehOdTFzbDd8
elMHvCj7FCI0L0LFXqbN/tuT/XEtPTSbYG24TGrWQSKEBkxajt6vLMUqXch4QoF2n7ybajVt7lgp6GZN
mRrFs3O3K4HWceIiPDVnm7K9I+X9ZNbGY+jRqIoyJahRmbUpA2orCx7sgZljumLJuN6Yv/OkWrCEE7sy
HE689bc2mCvnu0rNzfgkr/6yT603Mee+7nhMav6LXmaH0i/EiLY11apS3UWwDHt7hbsLN11+cCowhfkT
327Fo99tw91T1uPhGVtcC9FkKg2rsH3gr4/J/0UsgeAFmgJxkaG4STLmxJ93q5Wd7+pWX5vxpuef/aIJ
0JfgE3O24wWp/TV1Pkv5SWhYpQKqc30F4XJR27s00GbhVQi247IqEcpMIFVFWHC1YUK/e1z3gBw8m4b1
Ypc//t12zFh/VK2K7BBhwBqZfgBYwzHLes4YZG3ZrEYkHh/UDE8OboYJw5qjSfUI/aw7uZwWLHB9yhfm
78amY+dF1S54Xo4UpFFS8LgKER2C9G8Wh6taaa7NqdlwzUA61mAtS8FADcITahPzd5zC+JlbVCMlX0kB
5MjLQxOJh6Zxmo/Cy+vFunoLLohGwKXLSWeJN6aDEVYDLhc38ZpWWPtkP3wutn8zUfdHiu3Pwq80HfPl
skvTLDYsWDko+V6Er+F1KkhpCn/dwu8NSyB4gVmE2gFr6TmiltMBZV8psGbvxczYzcQ+5xz8fs3j8JNo
CsxwzNgOKbjGAiFUsylgDFiojeXXzFNttb+0PQqdjlLw6TvwyjY1MV+0C2ZeZnjzOg2esOBwSjKXC2dD
W28pWHT66g2jGHC58xvFFLp9Clcnkgyhn+B72P7Qpk40PhShQW9BxkpS635PxgGJk7/P2oKBUjtPX3dE
TQFOpft5ExNF0NAJam+JuytaxiEi1C7P1c6xwdZwR842jYI40b6fsKI2/vYGBSx9RLBxkabciZRMt94O
viNItLXxA5vi/2R7RDQOY4o3CRKBet5k6jA8E77fYbUhWLjDRi8WbNbAk65roxqeCJdZN5xTtKtTCfvP
pqNX46roLQXwdGq2aheg3wF2KRoFjg46zAKBNS8FAeF6/nM2H1cFmQ1z9L9AWkpB3J+Ujj5SoFtLhj/L
ZeHkgXyWUYi8wUKsnHV4gfcZbrUorBgOg+evaqE0HNr8hgNXnjee1bpWJdW4aJg07yw7iAf6XobJtyXg
k9Ed8N3YrmgkWtFUEQxmtiamorcIpsEtq+OyyhFIuiAmlV7Izb0rKjz6PjWrbzYdU3FCnw6/n0sv1Ibw
yYpDeG3BXmVO8Dn0ZkSqiTaRJfvmb+N59jx4gwuZvDB/lxIk/NYHv96MBbtPuzVK/tWwBIIXWMsa6vNd
3Ru4HHfSuWflClqhHdOjEaLFnu7278Xo8coSfCM2NQt6WJDdzXEIG6jMS65xLUVj+bR2taOVXd3vtWVq
DUEuB06eHhKvei76vLoUV0z6Fcv1tRQjJKNWpY9GH7ANIc7Hea4pQAcZhBme4TBgeD4RLaAxV33WqR4Z
pmp0g+eubKF6SQ4lpSnhMbZnI9SLqYCGlSuirvze3rl+oVWGuZwY2xoGv7kc907fhKryzpAgm1L5GUeG
qc52iSq6r8gnxdxhd2xf+faZGxORUCdGHTfTJC4Cs0Ro9HtjGfq8vhQfLj+otBgKcPYSmOO/pvztaxFX
vqujaEjD3loucb0E+85cxOwxXVxC8a+INTDJC+zOo+rpmTFoozOyzOshcmVg2q3GgB3WwrzOGEhDrYIx
bNzDZ7NLj4WC11FVPijPoNfbcI+aac/JC4gSgVI9SsvgrPmobdArszd4npoAVWlPqPGwIZMDkXgNa2TP
mpBhC5d7WVC9xcEFUa+NdhSuxuwJa2LPFnrW4vTARCesLLDGGhCskfl+7jEs1BKMAUFsl2C3bYMqFVV8
B0sYDOFhhsKJJtll1Sq6PFB5xj/dpjHuDZPEG1xaPiPXgcuqem9v+SthCQQLCwsXlslgYWHhwhIIFhYW
OsD/AxH4ZN8hUN9IAAAAAElFTkSuQmCC"></image>`;

const PNCI_BARCODE = `
<image preserveAspectRatio="none" id="barcode_image" x="0" y="0" width= "211" height="30" 
xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANMAAAAsCAYAAAD/w40VAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8
    YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAH/SURBVHhe7dO9rgFBGMbxpeMGqDW0EuEGiE5DoVWqSFTi
    DnQalYJK4xYUoleotCoFN+Bzz5n3mD17Psqn/P+Syc6878yy7BOEn3K5XBgEgY3ZbOZKYafTsbXzer3s
    ulgsrHY4HGz9fD7tGuf67Xbb5vl8PrpvNpu1mr+X53qtVuu9+nY+n6OziUTCrs1m03qPx8OuhUIhTKfT
    Nve1Xq8XnWs0GlYrFou23u/34e12i/puxPnncfuTyaTN3fd1w9/fnanVajb3tVKp9Odew+Ew+oxqtfqu
    frter1H/99n1em217XZr6/g+P+73u/WczWbzpz8ajd7dL65WqVRsXq/Xf+x1/LOkUqmoXi6XrebF94/H
    42jth/vd4uK9fr//robhbrezmvuN43ucyWRi88vlYmvH/W+utlqtbB0/0+12rZbJZH7U3Vgul9aL/3/T
    6TTqu/fzP67n3zk/TqdTeDwebT6fz6N9fgwGgzD5OQEgQJgAEcIEiBAmQIQwASKECRAhTIAIYQJECBMg
    QpgAEcIEiBAmQIQwASKECRAhTIAIYQJECBMgQpgAEcIEiBAmQIQwASKECRAhTIAIYQJECBMgQpgAEcIE
    iBAmQIQwASKECRAhTIAIYQJECBMgQpgAEcIEiBAmQIQwASKECRAhTIAIYQJECBMgQpgAEcIESATBB3Dr
    GQBQXwXtAAAAAElFTkSuQmCC"></image>`;
export const IretirePnciImages = {
	PNCI_BARCODE_OTHER: `
	<svg x="164.5" width="211" height="30" viewBox="0 0 211 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
	<title>Barcode image</title>
	<g id="barcode_image" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
	${PNCI_BARCODE}
	</g>
</svg>`,
	PNCI_BARCODE_COVER: `
	<svg x="171.5" y="37" width="269" height="54" viewBox="0 0 269 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
	<title>Barcode image</title>
	<g id="barcode_image" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
	${PNCI_BARCODE.replace('height="30"', 'height="54"').replace('width= "211"', 'width= "269"')}
	</g>
</svg>`,

	PNCI_LOGO_OTHER: `
	<svg x="436" width="94" height="30" viewBox="0 0 94 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
	<title>Logo image</title>
	<g id="logo_image" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
	${PNCI_LOGO}
	</g>
</svg>`,
	PNCI_LOGO_COVER: `
	<svg x="36" y="37" width="114" height="54" viewBox="0 0 114 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
	<title>Logo image</title>
	<g id="logo_image" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
	${PNCI_LOGO.replace('height="30"', 'height="54"').replace('width= "94"', 'width= "114"')}
	</g>
</svg>`
};
